import InfoIcon from '@mui/icons-material/Info';
import {Box, Button, CircularProgress, OutlinedInput, Stack, Typography} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import * as React from 'react';
import {Controller, useForm} from 'react-hook-form';
import ImageUploading from 'react-images-uploading';
import axios from '../../axios';
import {formatMaterialDate} from '../Service';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import UpdateInformationBox from '../profile/UdpateInformationBox';
import {Profile} from '../profile/queries/Profile';
import {useUserInfo} from '../userInfo/hooks/useUserInfo';
import Select from "@mui/material/Select";
import states from "../registration/state";
import MenuItem from "@mui/material/MenuItem";
import LocationCityIcon from '@mui/icons-material/LocationCity';
import FlagIcon from '@mui/icons-material/Flag';

const UpdateProfile = ({setUpdateMode}) => {
  const {profil, reload} = useUserInfo();
  const [isLoading, setIsLoading] = React.useState(false);
  const [imageError, setImageError] = React.useState(false);

  const submit = data => {
    setIsLoading(true);
    Profile.updateInformation(data).then(response => {
      setIsLoading(false);
      reload();
      setUpdateMode(false);
    });
  };

  const {
    control,
    formState: {errors},
    handleSubmit,
  } = useForm({
    defaultValues: {
      birthday: formatMaterialDate(profil.birthdate),
      phonenumber: profil.phoneNumber,
      lastName: profil.last_name,
      firstName: profil.first_name,
      mail: profil.email,
      address: profil.address,
      postalCode: profil.postalCode,
      image: `${axios.defaults.apiBaseURL}${profil.image}`,
      city: profil.city,
      countryCode: profil.country
    },
  });

  const {mode} = useDarkMode();

  return (
    <Box
      sx={{
        backgroundColor: mode.settings.cardBackgroundColor,
        borderRadius: 1,
        padding: '20px',
      }}>
      {profil && (
        <Stack gap={5}>
          <Typography variant={'subtitle7'} color={mode.settings.textColor3} >
            Informations générales
          </Typography>
          <Stack direction={'row'} gap={5} flexWrap={"wrap"} justifyContent={"center"}>
            <Controller
              control={control}
              name="image"
              rules={{
                required: true,
              }}
              render={({field: {onChange, value}}) => (
                <ImageUploading
                  value={value}
                  onChange={event => onChange(event[0].data_url)}
                  dataURLKey="data_url"
                  name={'eventImage'}
                  maxFileSize={8000000}
                >
                  {({onImageUpload, errors, onImageRemove}) => (
                    <ImageListItem onClick={() => {onImageRemove(1);onImageUpload()}}>
                      <img
                        src={value}
                        alt={'test'}
                        loading="lazy"
                        style={{width: 200, height: 200}}
                      />
                      <ImageListItemBar
                        title={'Changer la photo de profil'}
                        actionPosition={'left'}
                        sx={{height: 75, bottom : '89px'}}
                        actionIcon={
                          <IconButton
                            sx={{color: 'rgba(255, 255, 255, 0.54)'}}
                            aria-label={`info about`}>
                            <InfoIcon />
                          </IconButton>
                        }
                      />
                      {errors && <Box sx={{width : '190px', marginTop : '85px'}}>{
                          errors.maxFileSize &&
                          <Typography color={mode.settings.textColor6}>La taille de l'image ne doit pas dépasser 8Mb</Typography>
                      }</Box>}
                    </ImageListItem>
                  )}
                </ImageUploading>
              )}
            />

            <Stack
              style={{marginLeft: '20px'}}
              justifyContent={'space-between'} gap={1.5}>
              <Stack direction={'row'} spacing={2} alignItems={'center'} flexWrap={"wrap"}>
                <Typography
                    variant={'body2'}
                    color={mode.settings.textColor3}
                    component={'label'}
                    id={'label-firstName'}
                    htmlFor={'firstName'}
                >
                  Prénom
                </Typography>
                <Controller
                  control={control}
                  name="firstName"
                  rules={{
                    required: true,
                  }}
                  render={({field: {onChange, value}}) => (
                    <OutlinedInput
                      size="small"
                      id="firstName"
                      aria-describedby="label-firstName"
                      inputProps={{
                        'aria-label': 'weight',
                      }}
                      type={'text'}
                      value={value}
                      style={{width: 200, height: 35}}
                      sx={{
                        background: mode.settings.inputBackgroundColor,
                        color: mode.settings.textColor3,
                      }}
                      onChange={onChange}
                      error={!!errors.firstName}
                    />
                  )}
                />

                <Typography
                    variant={'body2'}
                    color={mode.settings.textColor3}
                    component={'label'}
                    id={'label-lastName'}
                    htmlFor={'lastName'}
                >
                  Nom
                </Typography>
                <Controller
                  control={control}
                  name="lastName"
                  rules={{
                    required: true,
                  }}
                  render={({field: {onChange, value}}) => (
                    <OutlinedInput
                      size="small"
                      id="lastName"
                      aria-describedby="label-lastName"
                      inputProps={{
                        'aria-label': 'weight',
                      }}
                      type={'text'}
                      value={value}
                      style={{width: 200, height: 35}}
                      sx={{
                        background: mode.settings.inputBackgroundColor,
                        color: mode.settings.textColor3,
                      }}
                      onChange={onChange}
                      error={!!errors.lastName}
                    />
                  )}
                />
              </Stack>
              <Controller
                control={control}
                name="birthday"
                rules={{
                  required: true,
                }}
                render={({field: {onChange, value}}) => (
                  <UpdateInformationBox
                    icon={'birthday'}
                    alt={'Date de naissance'}
                    label={'Date de naissance'}
                    info={value}
                    type={'date'}
                    setter={onChange}
                    error={!!errors.birthday}
                    id={'birthday'}
                  />
                )}
              />
              <Controller
                control={control}
                name="phonenumber"
                render={({field: {onChange, value}}) => (
                  <UpdateInformationBox
                    icon={'phone'}
                    alt={'Téléphone'}
                    label={'Téléphone'}
                    info={value}
                    type={'number'}
                    setter={onChange}
                    error={!!errors.phonenumber}
                    id={'phonenumber'}
                  />
                )}
              />
              <Controller
                control={control}
                name="mail"
                rules={{
                  required: true,
                }}
                render={({field: {onChange, value}}) => (
                  <UpdateInformationBox
                    icon={'mail'}
                    alt={'Email'}
                    label={'Email'}
                    info={value}
                    type={'text'}
                    setter={onChange}
                    error={!!errors.mail}
                    id={'mail'}
                  />
                )}
              />
              <Controller
                control={control}
                name="address"
                rules={{
                  required: true,
                }}
                render={({field: {onChange, value}}) => (
                  <UpdateInformationBox
                    icon={'location'}
                    alt={'Adresse'}
                    label={'Adresse'}
                    info={value}
                    type={'text'}
                    setter={onChange}
                    error={!!errors.address}
                    id={'address'}
                  />
                )}
              />
              <Controller
                  control={control}
                  name="postalCode"
                  rules={{
                    required: true,
                  }}
                  render={({field: {onChange, value}}) => (
                      <UpdateInformationBox
                          icon={'location'}
                          alt={'Code Postal'}
                          label={'Code Postal'}
                          info={value}
                          type={'text'}
                          setter={onChange}
                          error={!!errors.postalCode}
                          id={'postalCode'}
                      />
                  )}
              />
              <Controller
                  control={control}
                  name="city"
                  rules={{
                    required: true,
                  }}
                  render={({field: {onChange, value}}) => (
                      <UpdateInformationBox
                          icon={'none'}
                          alt={'Ville'}
                          label={'Ville'}
                          info={value}
                          type={'text'}
                          setter={onChange}
                          error={!!errors.city}
                          id={'city'}
                          iconMaterial={<LocationCityIcon sx={{fontSize : '32px', marginRight : '14px', color : '#3590d5'}}/>}
                      />
                  )}
              />
              <Controller
                  control={control}
                  name="countryCode"
                  rules={{
                    required: true,
                  }}
                  defaultValue={'FR'}
                  render={({field: {onChange, value}}) => (
                      <Stack direction={'row'} alignItems={'center'} justifyContent={"flex-start"} flexWrap={"wrap"}
                             gap={{xs : 2, md : 2, lg : 0}}
                      >
                        <FlagIcon sx={{fontSize : '32px', marginRight : '14px', color : '#3590d5'}}/>
                        <Typography
                            width={180}
                            color={mode.settings.textColor3}
                            display={{xs : 'none', md : 'none', lg : 'block'}}
                            component={'label'}
                            id={'label-'+'country'}
                            htmlFor={'input'+'country'}
                        >
                          Pays
                        </Typography>
                        <Select
                            labelId="label-country"
                            id="country"
                            value={value}
                            label="Pays"
                            onChange={e => onChange(e.target.value)}
                            error={!!errors.states}
                            sx={{
                              background :mode.settings.inputBackgroundColor,
                              color:mode.settings.textColor3, width: 200, height:35
                            }}
                            displayEmpty>
                          {states &&
                              Object.entries(states).map((option, index) => (
                                  <MenuItem
                                      key={index}
                                      value={option[0]}
                                      selected={option[1] === 'France'}>
                                    {option[1]}
                                  </MenuItem>
                              ))}
                        </Select>
                      </Stack>

                  )}
              />
            </Stack>
          </Stack>
          <Stack direction={'row'} sx={{alignSelf: 'flex-end'}} gap={5}>
            <Button
              className="btn-low"
              sx={{paddingRight: 3, paddingLeft: 3, backgroundColor : mode.settings.inputBackgroundColor}}
              onClick={() => setUpdateMode(false)}>
              <Typography
                variant={'subtitle3'}
                component="span"
                style={{color: mode.settings.textColor3}}>
                Annuler
              </Typography>
            </Button>
            <Button
              className="btn"
              onClick={handleSubmit(data => submit(data))}>
              {isLoading && (
                  <CircularProgress color="inherit" size={26} />
              )}
              {!isLoading && <img
                src={'/assets/icon/save.png'}
                alt={'Enregistrer'}
                style={{marginRight: '10px'}}
              />}
              <Typography variant={'subtitle3'} component="span">
                Enregistrer
              </Typography>
            </Button>
          </Stack>
        </Stack>
      )}
    </Box>
  );
};

export default UpdateProfile;
